export const API_URL = {
  reimbursementSetting:
    "/ms/spm-disbursement/v1/reimbursement/settings/settlement",
  previewReimbursementSetting:
    "/ms/spm-disbursement/v1/reimbursement/settings/settlement/preview",
  getTax: "/api/v1/tax",
};
